export default __webpack_public_path__ + "static/gab-e3f8d2b5ed6d49fc34a6f80ea4fe580e.jpg";